export default __webpack_public_path__ + "static/media/i.b0c6f8ea.svg";